import React from "react";
import Badge from "./Badge";

interface Props {
    items?: string[] | null
    colourVariant?: string
    emptyListValue?: string
}

const BadgeList = ({
    items,
    colourVariant = "brand",
    emptyListValue = "None",
}: Props) => {
    return (
        <div className="flex flex-row flex-wrap gap-1">
            {
                items?.length
                    ? items.filter(item => !!item).map((item, index) => <Badge key = {`${item}-${index}`} item={item} colourVariant={colourVariant}/>)
                    : (emptyListValue && <Badge item={emptyListValue} colourVariant={"red"}/>)
            }
        </div>
    );
};

export default BadgeList;